<ng-container>
  <div class="row align-items-center p-2">
    <!--           [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}"-->

    <div class="flex-shrink-1">
      <img
        src="ui-resources/{{offersSelected[0]?.article || offersSelected[0]?._article}}.png"
        class="img-fluid rounded pr-2" alt="{{offersSelected[0]?.article || offersSelected[0]?._article}}"
        title="{{'ARTICLE_TYPES.' + (offersSelected[0]?.article || offersSelected[0]?._article) | translate}}"
        style="height: 30px">
    </div>
    <div class="col d-flex d-xl-none" *ngIf="minimizedReview">
      <div class="row justify-content-start flex-nowrap text-truncate d-block">
        {{'ARTICLE_TYPES.' + (offersSelected[0]?.article || offersSelected[0]?._article) | translate}}
      </div>
    </div>
    <div class="col" *ngIf="!minimizedReview">
      <div class="row justify-content-start flex-nowrap text-truncate d-block">
        {{'ARTICLE_TYPES.' + (offersSelected[0]?.article || offersSelected[0]?._article) | translate}}
      </div>
    </div>
  </div>

  <!--sezioni colorate-->
  <ng-container
    *ngIf="(offersSelected[0]?.article || offersSelected[0]?._article) === ArticleFamilyConstants.PEC">
    <div class="row align-items-center p-2 mt-1 mb-2"
         *ngIf="data?.dataFromWarp?.result?.documento"
         [ngClass]="{'ml-2 border-left tertiary-border-color position-static':!minimizedReview}">
      <div class="col-12" *ngIf="!minimizedReview">
        <div
          class="row justify-content-start flex-nowrap text-truncate d-block tertiary-color font-weight-semibold">
          {{'DOCUMENT' | translate | uppercase}}
        </div>
      </div>
      <div class="col-12" *ngIf="!minimizedReview">
        <div class="row justify-content-start flex-nowrap text-truncate d-block">
          {{data?.dataFromWarp?.result?.documento}}
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
